import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import JobInformations from './JobInformations/JobInformations';
import ApplicationForm from './ApplicationForm/ApplicationForm';
import './PortalApplicationContent.scss';

export default function PortalApplicationContent() {
  return (
    <Container fluid className="d-flex flex-column px-5 pt-3 bg-light jobapp-container">
      <Row className='align-items-center mx-0'>
        <Col className="px-0">
          <Link to="/job-portal/home">
            <i className='mdi mdi-arrow-left fs-20' />
          </Link>
        </Col>
      </Row>
      <Row className='mx-0 mt-3'>
        <JobInformations />
      </Row>
      <Row className='mx-2'>
        <ApplicationForm />
      </Row>
    </Container>
  )
}
